import styles from "./teamvcard.module.scss";

type IconLinkProps = {
  icon: JSX.Element;
  href?: string;
  title?: string;
};

const IconLink = ({ icon, href, title }: IconLinkProps) => {
  return (
    <div className={styles.iconLinkContainer}>
      {href ? (
        <a href={href} title={title} target="_blank" rel="noreferrer">
          {icon}
        </a>
      ) : (
        icon
      )}
    </div>
  );
};

export default IconLink;
